import { PropertyKey } from '../../language/PropertyKey';

export const RESULT_FORMAT_KEY = Symbol('RESULT_FORMAT_KEY');

export const getResultFormat = (target: any, property: PropertyKey): string => {
  const format = Reflect.getOwnMetadata(RESULT_FORMAT_KEY, target, property);

  if (!format) {
    return '%o';
  }

  return format;
};

export const ResultFormat =
  (format: string) =>
  (target: any, property: PropertyKey): void => {
    Reflect.defineMetadata(RESULT_FORMAT_KEY, format, target, property);
  };
